import { jsx, jsxs } from "react/jsx-runtime";
import { useRef } from "react";
import classNames from "classnames";
import { useIsVisible } from "./hooks/useIsVisible.js";
import { useSize } from "./hooks/useSize.js";
import { useStopPropagation } from "./hooks/usestopPropagation.js";
import styles from "./components/HorizontalScroll/styles.module.scss";
const ROOT_MARGIN_OFFSET = "3px";
const HorizontalScroll = ({ children, childWidth, testId, ...rest }) => {
  const viewportRef = useRef(null);
  const leftRef = useRef(null);
  const rightRef = useRef(null);
  const leftIsVisible = useIsVisible(leftRef, 1, { root: viewportRef == null ? void 0 : viewportRef.current, rootMargin: ROOT_MARGIN_OFFSET }, true);
  const rightIsVisible = useIsVisible(rightRef, 1, { root: viewportRef == null ? void 0 : viewportRef.current, rootMargin: ROOT_MARGIN_OFFSET }, true);
  const { width: viewPortWidth = 0 } = useSize(viewportRef) || {};
  const isOverflowing = childWidth > viewPortWidth;
  const viewportClasses = classNames(styles.horizontalscroll__viewport, isOverflowing && styles["horizontalscroll__viewport--overflow"]);
  const hasAriaAttributes = rest["aria-label"] || rest["aria-labelledby"];
  useStopPropagation(viewportRef, ["touchstart", "touchmove"]);
  return /* @__PURE__ */ jsx("div", { className: styles.horizontalscroll, "data-testid": testId, children: /* @__PURE__ */ jsxs(
    "div",
    {
      className: viewportClasses,
      ref: viewportRef,
      tabIndex: hasAriaAttributes ? 0 : void 0,
      role: hasAriaAttributes ? "region" : void 0,
      ...rest,
      children: [
        /* @__PURE__ */ jsx(
          "div",
          {
            className: classNames(
              styles.horizontalscroll__indicator,
              styles["horizontalscroll__indicator--left"],
              !leftIsVisible && styles["horizontalscroll__indicator--visible"]
            )
          }
        ),
        /* @__PURE__ */ jsx(
          "div",
          {
            className: classNames(
              styles.horizontalscroll__indicator,
              styles["horizontalscroll__indicator--right"],
              !rightIsVisible && styles["horizontalscroll__indicator--visible"]
            )
          }
        ),
        /* @__PURE__ */ jsx("div", { ref: leftRef }),
        children,
        /* @__PURE__ */ jsx("div", { ref: rightRef })
      ]
    }
  ) });
};
export {
  HorizontalScroll as H
};
//# sourceMappingURL=HorizontalScroll.js.map
